(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9335,62788,4989],{

/***/ 32340:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Radio_Radio; }
});

// UNUSED EXPORTS: styles

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(45987);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/internal/SwitchBase.js
var SwitchBase = __webpack_require__(56608);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/createSvgIcon.js
var createSvgIcon = __webpack_require__(63786);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/internal/svg-icons/RadioButtonUnchecked.js


/**
 * @ignore - internal component.
 */

/* harmony default export */ var RadioButtonUnchecked = ((0,createSvgIcon/* default */.Z)( /*#__PURE__*/react.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), 'RadioButtonUnchecked'));
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/internal/svg-icons/RadioButtonChecked.js


/**
 * @ignore - internal component.
 */

/* harmony default export */ var RadioButtonChecked = ((0,createSvgIcon/* default */.Z)( /*#__PURE__*/react.createElement("path", {
  d: "M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"
}), 'RadioButtonChecked'));
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/withStyles.js + 1 modules
var withStyles = __webpack_require__(1591);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Radio/RadioButtonIcon.js






var styles = function styles(theme) {
  return {
    root: {
      position: 'relative',
      display: 'flex',
      '&$checked $layer': {
        transform: 'scale(1)',
        transition: theme.transitions.create('transform', {
          easing: theme.transitions.easing.easeOut,
          duration: theme.transitions.duration.shortest
        })
      }
    },
    layer: {
      left: 0,
      position: 'absolute',
      transform: 'scale(0)',
      transition: theme.transitions.create('transform', {
        easing: theme.transitions.easing.easeIn,
        duration: theme.transitions.duration.shortest
      })
    },
    checked: {}
  };
};
/**
 * @ignore - internal component.
 */

function RadioButtonIcon(props) {
  var checked = props.checked,
      classes = props.classes,
      fontSize = props.fontSize;
  return /*#__PURE__*/react.createElement("div", {
    className: (0,clsx_m/* default */.Z)(classes.root, checked && classes.checked)
  }, /*#__PURE__*/react.createElement(RadioButtonUnchecked, {
    fontSize: fontSize
  }), /*#__PURE__*/react.createElement(RadioButtonChecked, {
    fontSize: fontSize,
    className: classes.layer
  }));
}

 false ? 0 : void 0;
/* harmony default export */ var Radio_RadioButtonIcon = ((0,withStyles/* default */.Z)(styles, {
  name: 'PrivateRadioButtonIcon'
})(RadioButtonIcon));
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/colorManipulator.js
var colorManipulator = __webpack_require__(85160);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/capitalize.js
var capitalize = __webpack_require__(93871);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/createChainedFunction.js
var createChainedFunction = __webpack_require__(82568);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/RadioGroup/RadioGroupContext.js
var RadioGroupContext = __webpack_require__(79305);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/RadioGroup/useRadioGroup.js


function useRadioGroup() {
  return react.useContext(RadioGroupContext/* default */.Z);
}
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Radio/Radio.js













var Radio_styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      color: theme.palette.text.secondary
    },

    /* Pseudo-class applied to the root element if `checked={true}`. */
    checked: {},

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      '&$checked': {
        color: theme.palette.primary.main,
        '&:hover': {
          backgroundColor: (0,colorManipulator/* fade */.U1)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
          // Reset on touch devices, it doesn't add specificity
          '@media (hover: none)': {
            backgroundColor: 'transparent'
          }
        }
      },
      '&$disabled': {
        color: theme.palette.action.disabled
      }
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      '&$checked': {
        color: theme.palette.secondary.main,
        '&:hover': {
          backgroundColor: (0,colorManipulator/* fade */.U1)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
          // Reset on touch devices, it doesn't add specificity
          '@media (hover: none)': {
            backgroundColor: 'transparent'
          }
        }
      },
      '&$disabled': {
        color: theme.palette.action.disabled
      }
    }
  };
};
var defaultCheckedIcon = /*#__PURE__*/react.createElement(Radio_RadioButtonIcon, {
  checked: true
});
var defaultIcon = /*#__PURE__*/react.createElement(Radio_RadioButtonIcon, null);
var Radio = /*#__PURE__*/react.forwardRef(function Radio(props, ref) {
  var checkedProp = props.checked,
      classes = props.classes,
      _props$color = props.color,
      color = _props$color === void 0 ? 'secondary' : _props$color,
      nameProp = props.name,
      onChangeProp = props.onChange,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      other = (0,objectWithoutProperties/* default */.Z)(props, ["checked", "classes", "color", "name", "onChange", "size"]);

  var radioGroup = useRadioGroup();
  var checked = checkedProp;
  var onChange = (0,createChainedFunction/* default */.Z)(onChangeProp, radioGroup && radioGroup.onChange);
  var name = nameProp;

  if (radioGroup) {
    if (typeof checked === 'undefined') {
      checked = radioGroup.value === props.value;
    }

    if (typeof name === 'undefined') {
      name = radioGroup.name;
    }
  }

  return /*#__PURE__*/react.createElement(SwitchBase/* default */.Z, (0,esm_extends/* default */.Z)({
    color: color,
    type: "radio",
    icon: /*#__PURE__*/react.cloneElement(defaultIcon, {
      fontSize: size === 'small' ? 'small' : 'default'
    }),
    checkedIcon: /*#__PURE__*/react.cloneElement(defaultCheckedIcon, {
      fontSize: size === 'small' ? 'small' : 'default'
    }),
    classes: {
      root: (0,clsx_m/* default */.Z)(classes.root, classes["color".concat((0,capitalize/* default */.Z)(color))]),
      checked: classes.checked,
      disabled: classes.disabled
    },
    name: name,
    checked: checked,
    onChange: onChange,
    ref: ref
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ var Radio_Radio = ((0,withStyles/* default */.Z)(Radio_styles, {
  name: 'MuiRadio'
})(Radio));

/***/ }),

/***/ 37661:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ RadioGroup_RadioGroup; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(97685);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(45987);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/withStyles.js + 1 modules
var withStyles = __webpack_require__(1591);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/FormGroup/FormGroup.js






var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'wrap'
  },

  /* Styles applied to the root element if `row={true}`. */
  row: {
    flexDirection: 'row'
  }
};
/**
 * `FormGroup` wraps controls such as `Checkbox` and `Switch`.
 * It provides compact row layout.
 * For the `Radio`, you should be using the `RadioGroup` component instead of this one.
 */

var FormGroup = /*#__PURE__*/react.forwardRef(function FormGroup(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$row = props.row,
      row = _props$row === void 0 ? false : _props$row,
      other = (0,objectWithoutProperties/* default */.Z)(props, ["classes", "className", "row"]);

  return /*#__PURE__*/react.createElement("div", (0,esm_extends/* default */.Z)({
    className: (0,clsx_m/* default */.Z)(classes.root, className, row && classes.row),
    ref: ref
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ var FormGroup_FormGroup = ((0,withStyles/* default */.Z)(styles, {
  name: 'MuiFormGroup'
})(FormGroup));
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/useForkRef.js
var useForkRef = __webpack_require__(17294);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/useControlled.js
var useControlled = __webpack_require__(22775);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/RadioGroup/RadioGroupContext.js
var RadioGroupContext = __webpack_require__(79305);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/unstable_useId.js
var unstable_useId = __webpack_require__(95001);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/RadioGroup/RadioGroup.js










var RadioGroup = /*#__PURE__*/react.forwardRef(function RadioGroup(props, ref) {
  var actions = props.actions,
      children = props.children,
      nameProp = props.name,
      valueProp = props.value,
      onChange = props.onChange,
      other = (0,objectWithoutProperties/* default */.Z)(props, ["actions", "children", "name", "value", "onChange"]);

  var rootRef = react.useRef(null);

  var _useControlled = (0,useControlled/* default */.Z)({
    controlled: valueProp,
    default: props.defaultValue,
    name: 'RadioGroup'
  }),
      _useControlled2 = (0,slicedToArray/* default */.Z)(_useControlled, 2),
      value = _useControlled2[0],
      setValue = _useControlled2[1];

  react.useImperativeHandle(actions, function () {
    return {
      focus: function focus() {
        var input = rootRef.current.querySelector('input:not(:disabled):checked');

        if (!input) {
          input = rootRef.current.querySelector('input:not(:disabled)');
        }

        if (input) {
          input.focus();
        }
      }
    };
  }, []);
  var handleRef = (0,useForkRef/* default */.Z)(ref, rootRef);

  var handleChange = function handleChange(event) {
    setValue(event.target.value);

    if (onChange) {
      onChange(event, event.target.value);
    }
  };

  var name = (0,unstable_useId/* default */.Z)(nameProp);
  return /*#__PURE__*/react.createElement(RadioGroupContext/* default.Provider */.Z.Provider, {
    value: {
      name: name,
      onChange: handleChange,
      value: value
    }
  }, /*#__PURE__*/react.createElement(FormGroup_FormGroup, (0,esm_extends/* default */.Z)({
    role: "radiogroup",
    ref: handleRef
  }, other), children));
});
 false ? 0 : void 0;
/* harmony default export */ var RadioGroup_RadioGroup = (RadioGroup);

/***/ }),

/***/ 79305:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

/**
 * @ignore - internal component.
 */

var RadioGroupContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext();

if (false) {}

/* harmony default export */ __webpack_exports__["Z"] = (RadioGroupContext);

/***/ }),

/***/ 23059:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);

var _interopRequireWildcard = __webpack_require__(75263);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var React = _interopRequireWildcard(__webpack_require__(67294));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2108));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M16.59 7.58L10 14.17l-3.59-3.58L5 12l5 5 8-8zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), 'CheckCircleOutline');

exports.Z = _default;

/***/ }),

/***/ 33038:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contact",
      function () {
        return __webpack_require__(85210);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 62788:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4298);
/* harmony import */ var _CMSText__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94455);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* provided dependency */ var process = __webpack_require__(34155);






var SharedHead = function(param) {
    var datas = param.datas;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var favicon = (datas === null || datas === void 0 ? void 0 : (ref = datas.data) === null || ref === void 0 ? void 0 : ref.favicon) ? datas.data.favicon : null;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    var pageRoute = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        var basePath = 'https://' + (process.env.PUBLIC_DOMAIN || ( true ? window.location.host : 0));
        var locale = router.locale === router.defaultLocale ? '' : "/".concat(router.locale);
        var href = "".concat(basePath).concat(locale).concat(router.asPath);
        return href.endsWith('/') ? href.slice(0, -1) : href;
    }, [
        router.asPath,
        router.pathname,
        router.isReady
    ]);
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(next_head__WEBPACK_IMPORTED_MODULE_2__["default"], {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "viewport",
                content: "width=device-width, initial-scale=1, maximum-scale=1"
            }),
            (datas === null || datas === void 0 ? void 0 : (ref1 = datas.data) === null || ref1 === void 0 ? void 0 : ref1.meta_url) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: (0,_CMSText__WEBPACK_IMPORTED_MODULE_4__/* .prismicText */ .yz)(datas === null || datas === void 0 ? void 0 : (ref2 = datas.data) === null || ref2 === void 0 ? void 0 : ref2.meta_url)
            }),
            (datas === null || datas === void 0 ? void 0 : (ref3 = datas.data) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.meta_image) === null || ref4 === void 0 ? void 0 : ref4.url) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: datas === null || datas === void 0 ? void 0 : (ref5 = datas.data) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.meta_image) === null || ref6 === void 0 ? void 0 : ref6.url,
                name: "image"
            }),
            process.env.NO_INDEX === undefined && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: pageRoute
            }, "canonical"),
            (favicon === null || favicon === void 0 ? void 0 : favicon.url) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "apple-touch-icon",
                        sizes: "180x180",
                        href: favicon.url
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "icon",
                        type: "image/png",
                        sizes: "16x16 32x32 48x48",
                        href: favicon['small'].url
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_script__WEBPACK_IMPORTED_MODULE_3__["default"], {
                src: "https://unpkg.com/swiper@6.4.8/swiper-bundle.min.js"
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["default"] = (SharedHead);


/***/ }),

/***/ 8122:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _Header__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49841);
/* harmony import */ var _Footer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79956);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(86010);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9008);
/* harmony import */ var _utils_scrollState__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75216);
/* harmony import */ var _Global_SharedHead__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(62788);
/* harmony import */ var _Global_CMSText__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(94455);









var Layout = function(param) {
    var children = param.children, doc = param.doc, account = param.account, faq = param.faq, hideTop = param.hideTop, mainLogo = param.mainLogo, headerTitle = param.headerTitle, t = param.t, inStoreText = param.inStoreText, banner = param.banner, metaTitle = param.metaTitle, metaDescription = param.metaDescription, metaKeywords = param.metaKeywords, metaDescriptionProduct = param.metaDescriptionProduct, metaKeywordsProduct = param.metaKeywordsProduct, metaImage = param.metaImage, pageType = param.pageType, takeback = param.takeback, basket = param.basket, pageName = param.pageName;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11;
    var scrollState = (0,_utils_scrollState__WEBPACK_IMPORTED_MODULE_5__/* .useScrollState */ .M)();
    var isBanner = (0,_Global_CMSText__WEBPACK_IMPORTED_MODULE_7__/* .isPrismicText */ .LT)(banner === null || banner === void 0 ? void 0 : (ref = banner.data) === null || ref === void 0 ? void 0 : ref.text);
    var isDisplayedBannerOnAllPages = banner === null || banner === void 0 ? void 0 : (ref1 = banner.data) === null || ref1 === void 0 ? void 0 : ref1.is_displayed_banner_on_all_pages;
    var metaTitleString = metaTitle && (0,_Global_CMSText__WEBPACK_IMPORTED_MODULE_7__/* .isPrismicText */ .LT)(doc === null || doc === void 0 ? void 0 : (ref2 = doc.data) === null || ref2 === void 0 ? void 0 : ref2.baseline) ? "".concat((0,_Global_CMSText__WEBPACK_IMPORTED_MODULE_7__/* .prismicText */ .yz)(doc === null || doc === void 0 ? void 0 : (ref3 = doc.data) === null || ref3 === void 0 ? void 0 : ref3.baseline), " - ").concat(metaTitle) : metaTitle;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)('page', pageType && "page--".concat(pageType)),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Global_SharedHead__WEBPACK_IMPORTED_MODULE_6__["default"], {
                datas: doc
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(next_head__WEBPACK_IMPORTED_MODULE_4__["default"], {
                children: [
                    metaTitleString && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                                children: metaTitleString
                            }, "pageTitle"),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                property: "og:title",
                                name: "title",
                                content: metaTitleString
                            })
                        ]
                    }),
                    metaDescription && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        name: "description",
                        content: metaDescription
                    }),
                    (metaKeywords === null || metaKeywords === void 0 ? void 0 : metaKeywords.length) && ((ref4 = metaKeywords[0]) === null || ref4 === void 0 ? void 0 : ref4.text) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:keywords",
                        name: "keywords",
                        content: (0,_Global_CMSText__WEBPACK_IMPORTED_MODULE_7__/* .prismicText */ .yz)(metaKeywords)
                    }),
                    metaKeywordsProduct && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:keywords",
                        name: "keywords",
                        content: metaKeywordsProduct
                    }),
                    metaDescriptionProduct && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        name: "description",
                        content: metaDescriptionProduct
                    }),
                    metaImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                property: "og:image",
                                content: metaImage
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                name: "twitter:image",
                                content: metaImage
                            })
                        ]
                    })
                ]
            }),
            !(doc === null || doc === void 0 ? void 0 : (ref5 = doc.data) === null || ref5 === void 0 ? void 0 : ref5.hide_header) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Header__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                logo: mainLogo,
                t: t,
                title: headerTitle,
                inStoreText: inStoreText,
                doc: doc,
                account: account,
                faq: faq,
                showOnScrollUp: scrollState.showOnScrollUp,
                showOnTop: scrollState.showOnTop,
                textColor: doc === null || doc === void 0 ? void 0 : (ref6 = doc.data) === null || ref6 === void 0 ? void 0 : ref6.header_text_color,
                background: doc === null || doc === void 0 ? void 0 : (ref7 = doc.data) === null || ref7 === void 0 ? void 0 : ref7.header_background,
                hoverColor: doc === null || doc === void 0 ? void 0 : (ref8 = doc.data) === null || ref8 === void 0 ? void 0 : ref8.header_text_hover_color,
                basket: basket,
                takeback: takeback,
                submenuBackgroundColor: doc === null || doc === void 0 ? void 0 : (ref9 = doc.data) === null || ref9 === void 0 ? void 0 : ref9.header_submenu_background_color,
                submenuTextColor: doc === null || doc === void 0 ? void 0 : (ref10 = doc.data) === null || ref10 === void 0 ? void 0 : ref10.header_submenu_text_color,
                isBanner: isBanner,
                isDisplayedBannerOnAllPages: isDisplayedBannerOnAllPages,
                banner: banner,
                pageName: pageName
            }),
            children,
            !(doc === null || doc === void 0 ? void 0 : (ref11 = doc.data) === null || ref11 === void 0 ? void 0 : ref11.hide_footer) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Footer__WEBPACK_IMPORTED_MODULE_2__["default"], {
                doc: doc,
                t: t,
                hideTop: hideTop
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Layout);


/***/ }),

/***/ 75900:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41120);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75154);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Global_CMSText__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94455);




var useStyles = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(theme) {
    return (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        root: {
            display: 'block',
            height: 200,
            border: "1px solid ".concat(theme.palette.primary.main),
            textAlign: 'justify',
            overflowY: 'scroll',
            margin: theme.spacing(1),
            padding: theme.spacing(1)
        }
    });
});
var TextBox = function(param) {
    var text = param.text;
    var classes = useStyles();
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: text && text.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: classes.root,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Global_CMSText__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                data: text
            })
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (TextBox);


/***/ }),

/***/ 85210:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var _home_ubuntu_build_wl_front_1_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_ubuntu_build_wl_front_1_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_ubuntu_build_wl_front_1_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(41120);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(75154);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(41749);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(22318);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(64436);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36456);
/* harmony import */ var _redux_actions_prismic__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(64063);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(31567);
/* harmony import */ var _components_Button_Button__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(41107);
/* harmony import */ var _components_Layout_Layout__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8122);
/* harmony import */ var _components_TextField_TextField__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(59000);
/* harmony import */ var _components_TextField_TextBox__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(75900);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(86010);
/* harmony import */ var _components_Global_CMSText__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(94455);














function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var mapStateToProps = function(state) {
    return {
        cart: state.cart,
        parameters: state.parameters
    };
};
var useStyles = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(function(theme) {
    return (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({
        root: {
            background: theme.extraColors.greyLight,
            paddingTop: theme.spacing(10),
            paddingBottom: theme.spacing(10)
        },
        container: {
            background: theme.palette.common.white,
            maxWidth: 600,
            margin: 'auto',
            padding: theme.spacing(4)
        },
        alignCenter: {
            textAlign: 'center'
        },
        formControl: {
            minWidth: 120,
            width: '100%'
        },
        sizeSelector: {
            borderRadius: theme.shape.borderRadius,
            padding: theme.spacing(0.5, 2, 0.5, 1),
            margin: theme.spacing(0.5),
            backgroundColor: theme.extraColors.greyLight,
            minWidth: 200,
            color: theme.palette.common.black,
            height: 40,
            //fontWeight: 'bold',
            border: 'none'
        },
        textArea: {
            '& .input': {
                '& .MuiInput-root': {
                    position: 'initial',
                    width: '100%'
                },
                '& .MuiInput-underline': {
                    '&:before, &:after': {
                        display: 'none'
                    }
                }
            }
        },
        label: {
            paddingLeft: theme.spacing(1.25),
            marginBottom: theme.spacing(0.5),
            '& .paragraph-class': {
                margin: 0
            }
        },
        labelContainer: {
            cursor: 'pointer',
            fontSize: 9,
            minHeight: "calc(".concat(theme.typography.body2.lineHeight, "em * 2)}")
        },
        error: {
            background: 'none',
            '& .input': {
                borderColor: theme.palette.error.main
            }
        }
    });
});
var Contact = function(param) {
    var main = param.main, doc = param.doc, inStoreText = param.inStoreText, basket = param.basket, accountRes = param.accountRes, faqRes = param.faqRes, banner = param.banner;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19;
    var classes = useStyles();
    var ref20 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(''), firstname = ref20[0], setFirstname = ref20[1];
    var ref21 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(''), lastname = ref21[0], setLastname = ref21[1];
    var ref22 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(''), email = ref22[0], setEmail = ref22[1];
    var ref23 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(''), message = ref23[0], setMessage = ref23[1];
    var ref24 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(''), firstList = ref24[0], setFirstList = ref24[1];
    var ref25 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(''), secondList = ref25[0], setSecondList = ref25[1];
    var ref26 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), errorFields = ref26[0], setErrorFields = ref26[1];
    var ref27 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), mailSend = ref27[0], setMailSend = ref27[1];
    var ref28 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), errorMail = ref28[0], setErrorMail = ref28[1];
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_13__/* .useTranslation */ .$)().t;
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useDispatch */ .I0)();
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        dispatch((0,_redux_actions_prismic__WEBPACK_IMPORTED_MODULE_5__/* .SAVE_PRISMIC_DOCUMENTS */ .w)({
            general: main === null || main === void 0 ? void 0 : main.data,
            instore: inStoreText === null || inStoreText === void 0 ? void 0 : inStoreText.data
        }));
    }, [
        main,
        inStoreText
    ]);
    var handleFirstList = function(event) {
        setFirstList(event.target.value);
    };
    var handleSecondList = function(event) {
        setSecondList(event.target.value);
    };
    var sendData = function() {
        var _ref = _asyncToGenerator(_home_ubuntu_build_wl_front_1_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var response;
            return _home_ubuntu_build_wl_front_1_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setMailSend(false);
                        setErrorFields(false);
                        setErrorMail(false);
                        if (!(firstname !== '' && lastname !== '' && email !== '' && message !== '')) {
                            _ctx.next = 10;
                            break;
                        }
                        _ctx.next = 6;
                        return axios__WEBPACK_IMPORTED_MODULE_2___default()({
                            method: 'post',
                            url: "https://hook.eu1.make.com/vq11d9hqsm4cqyy5drm1c5211e5kl7sx",
                            data: {
                                firstname: firstname,
                                lastname: lastname,
                                shop: "adolfo-dominguez",
                                email: email,
                                message: message,
                                firstList: firstList,
                                secondList: secondList
                            }
                        });
                    case 6:
                        response = _ctx.sent;
                        if (response.status === 200) {
                            setMailSend(true);
                            setFirstname('');
                            setLastname('');
                            setEmail('');
                            setMessage('');
                            setFirstList('');
                            setSecondList('');
                            setErrorFields(false);
                        } else setErrorMail(true);
                        _ctx.next = 11;
                        break;
                    case 10:
                        {
                            setErrorFields(true);
                        }
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function sendData() {
            return _ref.apply(this, arguments);
        };
    }();
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_Layout_Layout__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            mainLogo: main === null || main === void 0 ? void 0 : (ref = main.data) === null || ref === void 0 ? void 0 : ref.logo,
            doc: main,
            t: t,
            inStoreText: inStoreText,
            "data-testid": "confirmation",
            metaTitle: (0,_components_Global_CMSText__WEBPACK_IMPORTED_MODULE_10__/* .prismicText */ .yz)(doc === null || doc === void 0 ? void 0 : (ref1 = doc.data) === null || ref1 === void 0 ? void 0 : ref1.meta_title_contact, t('texts:account:herotitle')),
            metaDescription: doc === null || doc === void 0 ? void 0 : (ref2 = doc.data) === null || ref2 === void 0 ? void 0 : ref2.meta_description_contact,
            metaKeywords: doc === null || doc === void 0 ? void 0 : (ref3 = doc.data) === null || ref3 === void 0 ? void 0 : ref3.meta_keywords_contact,
            hideTop: true,
            basket: basket,
            account: accountRes,
            faq: faqRes,
            banner: banner,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("section", {
                className: "contact-page ".concat(classes.root),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                    className: classes.container,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                            container: true,
                            spacing: 3,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                    item: true,
                                    xs: 12,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                        variant: 'h2',
                                        className: 'contact-page__title',
                                        align: "center",
                                        children: (0,_components_Global_CMSText__WEBPACK_IMPORTED_MODULE_10__/* .prismicText */ .yz)(doc === null || doc === void 0 ? void 0 : (ref4 = doc.data) === null || ref4 === void 0 ? void 0 : ref4.title_contact, t('texts:customer_survey:main_title'))
                                    })
                                }),
                                (doc === null || doc === void 0 ? void 0 : (ref5 = doc.data) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.desc_contact) === null || ref6 === void 0 ? void 0 : ref6.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                    item: true,
                                    xs: 12,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                        variant: 'body1',
                                        align: "center",
                                        children: (0,_components_Global_CMSText__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP)({
                                            data: doc === null || doc === void 0 ? void 0 : (ref7 = doc.data) === null || ref7 === void 0 ? void 0 : ref7.desc_contact,
                                            defaultText: t('texts:customer_survey:desc_contact'),
                                            asText: false
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                    item: true,
                                    xs: 6,
                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(errorFields && firstname === '' && [
                                        'field--error',
                                        classes.error
                                    ]),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_TextField_TextField__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                        label: "".concat(t('texts:account:firstname'), " *"),
                                        type: "text",
                                        name: "firstname",
                                        placeholder: t('texts:account:firstname'),
                                        value: firstname,
                                        required: true,
                                        onChange: setFirstname
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                    item: true,
                                    xs: 6,
                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(errorFields && lastname === '' && [
                                        'field--error',
                                        classes.error
                                    ]),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_TextField_TextField__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                        label: "".concat(t('texts:account:lastname'), " *"),
                                        type: "text",
                                        name: "lastname",
                                        placeholder: t('texts:account:lastname'),
                                        value: lastname,
                                        required: true,
                                        onChange: setLastname
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                    item: true,
                                    xs: 12,
                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(errorFields && email === '' && [
                                        'field--error',
                                        classes.error
                                    ]),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_TextField_TextField__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                        label: "".concat(t('texts:account:email'), " *"),
                                        type: "text",
                                        name: "email",
                                        placeholder: t('texts:account:email'),
                                        value: email,
                                        required: true,
                                        onChange: setEmail
                                    })
                                }),
                                (doc === null || doc === void 0 ? void 0 : (ref8 = doc.data) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.list_1_label) === null || ref9 === void 0 ? void 0 : ref9.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                    item: true,
                                    xs: 12,
                                    sm: 6,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                        variant: "outlined",
                                        className: classes.formControl,
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("label", {
                                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)('label', classes.label),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_Global_CMSText__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP, {
                                                    data: doc.data.list_1_label
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("select", {
                                                value: firstList,
                                                onChange: handleFirstList,
                                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)('contact_select', classes.sizeSelector),
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("option", {
                                                        "aria-label": "None",
                                                        value: ""
                                                    }),
                                                    (doc === null || doc === void 0 ? void 0 : (ref10 = doc.data) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.options_list_1) === null || ref11 === void 0 ? void 0 : ref11.length) > 0 && (doc === null || doc === void 0 ? void 0 : (ref12 = doc.data) === null || ref12 === void 0 ? void 0 : ref12.options_list_1.map(function(option, index) {
                                                        return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("option", {
                                                            value: (0,_components_Global_CMSText__WEBPACK_IMPORTED_MODULE_10__/* .prismicText */ .yz)(option === null || option === void 0 ? void 0 : option.option),
                                                            children: (0,_components_Global_CMSText__WEBPACK_IMPORTED_MODULE_10__/* .prismicText */ .yz)(option === null || option === void 0 ? void 0 : option.option)
                                                        }, index));
                                                    }))
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                (doc === null || doc === void 0 ? void 0 : (ref13 = doc.data) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.list_2_label) === null || ref14 === void 0 ? void 0 : ref14.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                    item: true,
                                    xs: 12,
                                    sm: 6,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                        variant: "outlined",
                                        className: classes.formControl,
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("label", {
                                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)('label', classes.label),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_Global_CMSText__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP, {
                                                    data: doc.data.list_2_label
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("select", {
                                                value: secondList,
                                                onChange: handleSecondList,
                                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)('contact_select', classes.sizeSelector),
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("option", {
                                                        "aria-label": "None",
                                                        value: ""
                                                    }),
                                                    (doc === null || doc === void 0 ? void 0 : (ref15 = doc.data) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.options_list_2) === null || ref16 === void 0 ? void 0 : ref16.length) > 0 && (doc === null || doc === void 0 ? void 0 : (ref17 = doc.data) === null || ref17 === void 0 ? void 0 : ref17.options_list_2.map(function(option, index) {
                                                        return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("option", {
                                                            value: (0,_components_Global_CMSText__WEBPACK_IMPORTED_MODULE_10__/* .prismicText */ .yz)(option === null || option === void 0 ? void 0 : option.option),
                                                            children: (0,_components_Global_CMSText__WEBPACK_IMPORTED_MODULE_10__/* .prismicText */ .yz)(option === null || option === void 0 ? void 0 : option.option)
                                                        }, index));
                                                    }))
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                    item: true,
                                    xs: 12,
                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(errorFields && message === '' && [
                                        'field--error',
                                        classes.error
                                    ]),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_TextField_TextField__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                        multiline: true,
                                        textArea: true,
                                        rows: 4,
                                        rowsMax: 4,
                                        type: 'textarea',
                                        name: 'message',
                                        value: message,
                                        onChange: setMessage,
                                        placeholder: t('texts:customer_survey:message'),
                                        label: "".concat(t('texts:customer_survey:message'), " *"),
                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)('textarea', classes.textArea)
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                    item: true,
                                    xs: 12,
                                    className: classes.alignCenter,
                                    children: [
                                        errorFields && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                            variant: 'body1',
                                            children: t('texts:customer_survey:error_fields')
                                        }),
                                        mailSend && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                            variant: 'body1',
                                            children: t('texts:account:email_send')
                                        }),
                                        errorMail && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                            variant: 'body1',
                                            children: t('texts:account:error_happend')
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                    item: true,
                                    xs: 12,
                                    className: classes.alignCenter,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_Button_Button__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                        variant: 'contained',
                                        color: 'secondary',
                                        className: "contact-page__submit",
                                        onClick: function() {
                                            return sendData();
                                        },
                                        children: t('texts:customer_survey:send')
                                    })
                                })
                            ]
                        }),
                        (0,_components_Global_CMSText__WEBPACK_IMPORTED_MODULE_10__/* .isPrismicText */ .LT)(doc === null || doc === void 0 ? void 0 : (ref18 = doc.data) === null || ref18 === void 0 ? void 0 : ref18.data_text) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_TextField_TextBox__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                            text: doc === null || doc === void 0 ? void 0 : (ref19 = doc.data) === null || ref19 === void 0 ? void 0 : ref19.data_text
                        })
                    ]
                })
            })
        })
    }));
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = ((0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .connect */ .$j)(mapStateToProps)(Contact));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [282,2215,15350,79593,68480,1111,57443,94108,74805,230,19789,29705,79956,49774,92888,40179], function() { return __webpack_exec__(33038); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);